import React from "react";
import "./CustomToast.css";

const CustomToast = ({
  title,
  content,
  onConfirm,
  onCancel,
  blocks = [],
  isNotifyMultiple,
  isError = false,
}) => (
  <div className={`sx-toast${isError ? " sx-toast--error" : ""}`}>
    {(title || content) && (
      <div className="sx-toast-body">
        {title ? (
          <strong className="sx-toast-title">
            {isError ? <span className="sx-toast-status-dot" aria-hidden /> : null}
            {title}
          </strong>
        ) : null}
        {content ? (
          <p className="sx-toast-content">
            {!title && isError ? (
              <span className="sx-toast-status-dot" aria-hidden />
            ) : null}
            {content}
          </p>
        ) : null}
      </div>
    )}

    {isNotifyMultiple && (
      <p className="sx-toast-note">
        Note: Any text overflowing in the credits preview won&apos;t appear in
        the final rendered video.
      </p>
    )}

    {isNotifyMultiple && blocks.length > 0 && (
      <ul className="sx-toast-list">
        {blocks.map((block) => (
          <li key={block.index}>Credit Block: {block.name}</li>
        ))}
      </ul>
    )}

    {onConfirm && (
      <div className="sx-toast-actions">
        <button type="button" className="cancell_btn" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="confirm_btn" onClick={onConfirm}>
          Confirm
        </button>
      </div>
    )}
  </div>
);

export default CustomToast;

const baseToastConfig = {
  position: "top-center",
  className: "Customtoastpop",
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
  style: {
    background: "transparent",
    boxShadow: "none",
    padding: 0,
    minHeight: "auto",
    width: "auto",
  },
};

export const defaultcustomToatStyle = {
  ...baseToastConfig,
  autoClose: 5500,
  closeOnClick: false,
};

export const customToatStyle = {
  ...baseToastConfig,
  autoClose: 3500,
};

export const customToatStyleError = {
  ...baseToastConfig,
  className: "Customtoastpop Customtoastpop--error",
  autoClose: 5000,
  closeOnClick: true,
};
